const daysOffRequest = {
    0: {
        name: 'Edit Days Off Request',
        authRule: 'editDayTypeRequest'
    }
};

export default daysOffRequest;



// WEBPACK FOOTER //
// ./src/Components/Schedule/utils/live-schedules/context-menu-arrays/daysOffRequest.js